export default __webpack_public_path__ + "static/media/cloe.c49f7a99.svg";